<template>

  <v-select :label="'Type'"
            v-model="selectedType"
            :items="types"
            :clearable="true"></v-select>

</template>

<script>

export default {
  name: 'ClubTypeSelector',
  props: ['currentType'],
  data () {
    return {
      types: [
        'club',
        'association',
        'organization',
        'league',
        'high school',
        'college'
      ],

      selectedType: null
    }
  },
  mounted () {
    if (this.currentType) {
      this.selectedType = this.currentType
    } else {
      this.selectedType = ''
    }
  },
  methods: {
    clear () {
      this.selectedType = ''
    }
  },
  watch: {
    'selectedType' () {
      this.$emit('typeSelected', this.selectedType || '')
    },
    'currentType' () {
      if (this.currentType) {
        this.selectedType = this.currentType
      } else {
        this.selectedType = ''
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ClubTypeSelector.vue